import { connect, mapReadPretty } from '@eastcoal/formily/exports/react'

import { MemberAgentCascader as LocalMemberAgentCascader } from '../../components/MemberAgentCascader'

export const MemberAgentCascader = connect(
  LocalMemberAgentCascader,
  mapReadPretty(LocalMemberAgentCascader, {
    disabled: true
  })
)
